import styled from '@emotion/styled';
import { Dialog, Box, Typography } from '@mui/material';

// ========================================
// Main Dialog Container
// ========================================
export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    position: fixed;
    right: 0;
    top: 100px;
    bottom: 0;
    width: 940px;
    height: auto;
    margin: 0;
    max-width: none;
    max-height: none;
    border-radius: 0;
    background: 'var(--bg-color)';
    display: flex;
    flex-direction: column;
    background-color: 'var(--bg-color)';
  }
  & .MuiBackdrop-root {
    background-color: transparent;
  }
`;

// ========================================
// Fixed Header Wrapper
// ========================================
export const FixedHeaderWrapper = styled(Box)`
  position: sticky;
  top: 0;
  background: #ffffff;
  z-index: 10;
  padding: 20px 32px 0;
  flex-shrink: 0;
`;

// ========================================
// Scrollable Content Wrapper
// ========================================
export const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px 32px 20px;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

// ========================================
// Header Section
// ========================================
export const HeaderSection = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
  flex-shrink: 0;
`;

export const HeaderLeft = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const HeaderRight = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const TitleTypography = styled(Typography)`
  font-family: 'Lufga', sans-serif;
  font-weight: 500;
  font-size: 32px;
  line-height: 100%;
  color: #0f52ba;
`;

export const TitleReferenceTypography = styled(Typography)`
  font-family: 'Lufga', sans-serif;
  font-weight: 500;
  font-size: 24px;
  line-height: 100%;
  color: #75838a;
`;

export const CloseIcon = styled(Box)`
  width: 24px;
  height: 24px;
  color: #75838a;
  cursor: pointer;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: #0b2330;
  }
`;

export const ActionMenuButton = styled(Box)`
  width: 24px;
  height: 24px;
  min-width: 24px;
  font-size: 24px;
  color: #75838a;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: transparent;
  border: none;

  &:hover {
    color: #0b2330;
  }
`;

// ========================================
// Customer & Date Row
// ========================================
export const CustomerDateRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-shrink: 0;
`;

export const InfoBlock = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InfoBlockRight = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`;

export const LabelTypography = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: #75838a;
`;

export const ValueTypography = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #0b2330;
`;

// ========================================
// Main Content Grid (Left + Right Columns)
// ========================================
export const MainContentGrid = styled(Box)`
  display: grid;
  grid-template-columns: 560px 1fr;
  gap: 12px;
  align-items: start;
  flex-shrink: 0;
`;

export const LeftColumn = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RightColumn = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

// ========================================
// Delivery Box (with expandable content support)
// ========================================
export const DeliveryBox = styled(Box)`
  width: 100%;
  background: #fafafa;
  border-radius: 8px;
  padding: 12px;
  box-sizing: border-box;
`;

export const DeliveryRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DeliveryFieldBox = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const DeliveryFieldBoxRight = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`;

export const DeliveryNoteContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const DeliveryNoteContent = styled(Box)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #0b2330;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

// ========================================
// Approve/Reject Box
// ========================================
export const ApproveBox = styled(Box)`
  width: 100%;
  border-radius: 8px;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
`;

export const RejectionNoteBox = styled(Box)`
  background-color: #e85e510f;
  margin: 8px -12px;
  padding: 8px 12px;
  box-sizing: border-box;
`;

export const RejectionLabelTypography = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: #e85e51;
  margin-bottom: 8px;
`;

// ========================================
// Address Boxes
// ========================================
export const AddressBox = styled(Box)`
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #dfdfdf;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
`;

export const AddressLabel = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: #75838a;
  margin-bottom: 12px;
`;

export const ContactRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const ContactName = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: #003572;
`;

export const AddressText = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 160%;
  color: #0b2330;
  letter-spacing: 0.5px;
`;

export const BuildingIcon = styled(Box)`
  width: 16px;
  height: 16px;
  color: #003572;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// ========================================
// Check Payments Button
// ========================================
export const CheckPaymentsButton = styled(Box)`
  display: inline-flex;
  align-items: center;
  padding: 8px 12px 8px 8px;
  gap: 6px;
  background: #f1f7ff;
  border-radius: 8px;
  cursor: pointer;
  align-self: flex-start;
  margin-top: 8px;

  &:hover {
    background: #e3efff;
  }
`;

export const WalletIcon = styled(Box)`
  width: 12px;
  height: 12px;
  color: #0f52ba;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CheckPaymentsText = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: #0f52ba;
`;

// ========================================
// Items Section
// ========================================
export const ItemsSection = styled(Box)`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

export const ItemsSectionTitle = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: #0b2330;
  margin-bottom: 12px;
`;

export const ItemsAndTotalsRow = styled(Box)`
  display: grid;
  grid-template-columns: 560px 1fr;
  gap: 12px;
  align-items: stretch;
`;

export const ItemsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #d9f1ff;
  border-radius: 8px;
  overflow: hidden;
`;

export const ItemBox = styled(Box)`
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;

export const ItemColumnName = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 170px;
  flex-shrink: 0;
`;

export const ItemColumnQuantity = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
  width: 90px;
  margin-right: 16px;
  flex-shrink: 0;
`;

export const ItemColumnRight = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
  min-width: 110px;
  flex-shrink: 0;
  padding-right: 4px;
`;

export const ItemLabel = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: #75838a;
`;

export const ItemValue = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: #0b2330;
`;

// ========================================
// Totals Box
// ========================================
export const TotalsBox = styled(Box)`
  width: 100%;
  min-width: 320px;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #d9f1ff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const TotalsTitle = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: #75838a;
  margin-bottom: 12px;
`;

export const TotalsRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const TotalsLabel = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: #0b2330;
`;

export const TotalsLabelBold = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: #0b2330;
`;

export const TotalsLabelOrange = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: #e85e51;
`;

export const TotalsLabelBlue = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: #0f52ba;
`;

export const TotalsValue = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: #0b2330;
  text-align: right;
`;

export const TotalsValueBold = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: #0b2330;
  text-align: right;
`;

export const TotalsValueOrange = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: #e85e51;
  text-align: right;
`;

export const TotalsValueBlue = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: #0f52ba;
  text-align: right;
`;

export const GrandTotalBox = styled(Box)`
  box-sizing: border-box;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d9f1ff;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
`;

export const PaidAmountBox = styled(Box)`
  width: 100%;
  background: #fafafa;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 8px;
`;

export const PaidTopRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const PaidTopLabel = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: #0b2330;
`;

export const PaidTopValue = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: #0b2330;
  text-align: right;
`;

export const PaidDivider = styled(Box)`
  box-sizing: border-box;
  width: 100%;
  height: 0px;
  margin: 12px 0;
  border-top: 1px solid #dfdfdf;
`;

export const PaidBottomRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const PaidBottomLabel = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: #f0a34a;
`;

export const PaidBottomValue = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: #0b2330;
  text-align: right;
`;

// ========================================
// Tooltip Components
// ========================================
export const LabelWithIcon = styled(Box)`
  display: flex;
  align-items: center;
`;

export const TooltipContainer = styled(Box)`
  padding: 12px;
  min-width: 200px;
`;

export const TooltipTitle = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 8px;
`;

export const TooltipRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  gap: 16px;
`;

export const TooltipLabel = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
`;

export const TooltipValue = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-size: 13px;
  color: #ffffff;
  font-weight: 500;
`;

export const TooltipTotalRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  gap: 16px;
`;

export const TooltipTotalLabel = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
`;

export const TooltipTotalValue = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
`;

export const InfoIconStyled = styled(Box)`
  font-size: 16px;
  color: #75838a;
  margin-left: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: #0f52ba;
  }
`;

export const InfoIconBlue = styled(Box)`
  font-size: 16px;
  color: #75838a;
  margin-left: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: #0f52ba;
  }
`;
